import { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from "react-country-flag";

const languages = [
  { code: 'en', name: 'English', country: 'GB' },
  { code: 'tr', name: 'Türkçe', country: 'TR' },
  { code: 'de', name: 'Deutsch', country: 'DE' },
  { code: 'fr', name: 'Français', country: 'FR' },
  { code: 'es', name: 'Español', country: 'ES' },
  { code: 'pt', name: 'Português', country: 'PT' },
  { code: 'kr', name: '한국어', country: 'KR' },
  { code: 'cn', name: '简体中文', country: 'CN' },
  { code: 'jp', name: '日本語', country: 'JP' }
];

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const currentLanguage = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <Box>
      <Tooltip title={t('header.change_language', 'Change Language')} arrow>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <ReactCountryFlag 
            countryCode={currentLanguage.country} 
            svg 
            style={{ width: '1.5em', height: '1.5em', borderRadius: '2px' }} 
            title={currentLanguage.name}
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="language-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={i18n.language === lang.code}
            onClick={() => changeLanguage(lang.code)}
          >
            <ReactCountryFlag 
              countryCode={lang.country} 
              svg 
              style={{ width: '1.5em', height: '1.5em', borderRadius: '2px', marginRight: '8px' }} 
              title={lang.name}
            />
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default LanguageSwitcher;
